import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/food-app/projects/$project_id")({
  component: () => <Outlet />,
  parseParams: (params) => ({
    project_id: parseInt(params.project_id, 10),
  }),
});
